import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Visibility from '@mui/icons-material/Visibility';
import InfoIcon from '@mui/icons-material/Info';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DeleteIcon from '@mui/icons-material/Delete';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { makeStyles } from '@material-ui/core/styles';
import MDBox from 'components/MDBox';
import { Badge, Skeleton, Stack, TableSortLabel, Tooltip } from '@mui/material';
import moment from 'moment/moment';
import RoomIcon from '@mui/icons-material/Room';
import { gpsStatusBadgeColor } from 'utils/constant';
import {
    TableVirtuoso
} from 'react-virtuoso';
import "react-virtualized/styles.css";
import { TablePaginationActions } from '../CustomPaginationTable';
import crudsService from 'services/cruds-service';

function Row(props) {
    const { group, columns, subColumns, clickExportHandler, clickViewHandler, clickDeleteHandler, openLogs, clickInfoHandler, clickSubRouteViewHandler } = props;
    const [open, setOpen] = React.useState(false);
    const [trackingPointData, setTrackingPointData] = React.useState([])
    const [loader, setLoader] = React.useState(false)

    async function openCollapse(value) {
        setOpen(value)
        if (value) {
            setLoader(true)
            try {
                let resp = await crudsService.getTrackingPoint(group.header.route_id)
                if (resp?.success) {
                    setTrackingPointData(resp.data)
                }
            } catch (error) {
                console.error('openCollapse', error)
            }
            setLoader(false)
        }
    }

    function Loading() {
        return (
            <Stack spacing={1}>
                <Skeleton variant="rectangular" height={30} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            </Stack>
        )
    }

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => openCollapse(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                {columns.map((column) => (
                    <TableCell key={column.accessor} width={column.width} style={{ fontSize: '0.875rem', fontWeight: '400', color: '#ffffff', opacity: 1 }}>
                        {column.accessor === 'actions' ? (
                            <Box display="flex" alignItems="center">
                                {['Info Route', 'View Route', 'Export Route'].map((action, index) => (
                                    <Tooltip key={index} title={action}>
                                        <IconButton onClick={() => {
                                            switch (action) {
                                                case 'Info Route':
                                                    clickInfoHandler(group.header);
                                                    break;
                                                case 'View Route':
                                                    clickViewHandler(group.header);
                                                    break;
                                                case 'Export Route':
                                                    clickExportHandler(group.header.route_id);
                                                    break;
                                                default:
                                            }
                                        }}>
                                            {action === 'Info Route' ? <InfoIcon /> : action === 'View Route' ? <Visibility /> : <FileDownloadIcon />}
                                        </IconButton>
                                    </Tooltip>
                                ))}
                                {clickDeleteHandler && (
                                    <Tooltip title="Delete Route">
                                        <IconButton onClick={(e) => clickDeleteHandler(e, group.header.route_id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Box>
                        ) : column?.Cell ? (
                            column.Cell(group.header[column.accessor], group.header)
                        ) : (
                            group.header[column.accessor]
                        )
                        }
                    </TableCell>
                ))}
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={18}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ width: '100%' }}>
                            {
                                loader ?
                                    <Loading /> :
                                    <TableContainer component={Paper} sx={{ overflowX: 'auto', margin: 1, width: '100%' }}>
                                        <Box sx={{ minWidth: '2180px', height: '600px' }}>
                                            <TableVirtuoso
                                                data={trackingPointData}
                                                fixedHeaderContent={() => (
                                                    <TableRow>
                                                        {subColumns
                                                            .filter(column => column.show !== false)
                                                            .map(column => (
                                                                <TableCell key={column.accessor} variant="head" style={{ textAlign: column.align, width: column.width }} >
                                                                    {column.Header}
                                                                </TableCell>
                                                            ))
                                                        }
                                                    </TableRow>
                                                )}
                                                itemContent={(index, child) =>
                                                    subColumns.map((column, colIndex) => {
                                                        const accessor = column.accessor;

                                                        const commonProps = {
                                                            key: accessor,
                                                            sx: {
                                                                paddingTop: '0px !important',
                                                                paddingBottom: '0px !important',
                                                                fontSize: '0.875rem',
                                                                borderBottom: 'unset',
                                                                color: '#ffffff',
                                                                width: column.width,
                                                                // textAlign: 'left',
                                                                padding: '10px 0px',
                                                                paddingLeft: '4px',
                                                                borderBottom: '0.5px solid #ced4da',
                                                                textAlign: column.align
                                                            }
                                                        };

                                                        if (['latitude', 'longitude', 'heading', 'timestamp', 'actions'].includes(accessor)) {
                                                            if (accessor === 'actions') {
                                                                return (
                                                                    <TableCell {...commonProps}>
                                                                        <Box display="flex" alignItems="center">
                                                                            <Tooltip title="View Info">
                                                                                <IconButton onClick={() => clickSubRouteViewHandler(child)}>
                                                                                    <Visibility />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </Box>
                                                                    </TableCell>
                                                                );
                                                            } else {
                                                                return (
                                                                    <TableCell {...commonProps}>
                                                                        {accessor === 'timestamp'
                                                                            ? moment(child[accessor]).format('MMMM DD, YYYY h:mm:ss A')
                                                                            : child[accessor]}
                                                                    </TableCell>
                                                                );
                                                            }
                                                        }

                                                        if (accessor === 'status') {
                                                            return (
                                                                <TableCell {...commonProps}>
                                                                    {child['status'] ? (
                                                                        <Badge
                                                                            color={gpsStatusBadgeColor(child['status'])}
                                                                            variant="standard"
                                                                            badgeContent={child['status']}
                                                                            style={{ marginLeft: '20px' }}
                                                                        />
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </TableCell>
                                                            );
                                                        }

                                                        if (accessor === 'speed') {
                                                            return (
                                                                <TableCell {...commonProps}>
                                                                    {child['DeviceMonitorParameterValue']?.value?.convert_position_speed} mph
                                                                </TableCell>
                                                            );
                                                        }

                                                        if (accessor === 'geofence_id' && child['geofence_id']) {
                                                            return (
                                                                <TableCell {...commonProps}>
                                                                    {child['Geofence'].name}
                                                                </TableCell>
                                                            );
                                                        }

                                                        if (accessor === 'geofence_event_id' && child['geofence_event_id']) {
                                                            return (
                                                                <TableCell {...commonProps}>
                                                                    {child['GeofenceEvent'].event_type}
                                                                </TableCell>
                                                            );
                                                        }

                                                        if (accessor === 'ignition_on') {
                                                            return (
                                                                <TableCell {...commonProps}>
                                                                    {child['ignition_on'] !== 0 ? 'True' : 'False'}
                                                                </TableCell>
                                                            );
                                                        }

                                                        if (accessor === 'point_id') {
                                                            return (
                                                                <TableCell {...commonProps}>
                                                                    {child['point_id']}{' '}
                                                                    {index === 0 && <RoomIcon title="Started Route" sx={{ color: 'green', fontSize: '20px !important' }} />}
                                                                    {(index === trackingPointData.length - 1 && group.header?.end_time) && (
                                                                        <RoomIcon sx={{ color: 'red', fontSize: '20px !important' }} />
                                                                    )}
                                                                </TableCell>
                                                            );
                                                        }

                                                        if (accessor === 'place_type') {
                                                            return (
                                                                <TableCell {...commonProps}>
                                                                    {child['DeviceMonitorParameterValue']?.value?.reverse_geocoded_address?.types?.join(', ') || ''}
                                                                </TableCell>
                                                            );
                                                        }

                                                        if (accessor === 'place_location') {
                                                            return (
                                                                <TableCell {...commonProps}>
                                                                    {child['DeviceMonitorParameterValue']?.value?.reverse_geocoded_address?.formatted_address ?? ''}
                                                                </TableCell>
                                                            );
                                                        }

                                                        if (
                                                            [
                                                                'can_engine_rpm',
                                                                'can_fuel_level',
                                                                'convert_can_intake_map',
                                                                'can_engine_load_level',
                                                                'can_throttle_pedal_level',
                                                                'convert_can_intake_air_temperature',
                                                                'convert_can_engine_coolant_temperature',
                                                                'vehicle_vin'
                                                            ].includes(accessor)
                                                        ) {
                                                            return (
                                                                <TableCell {...commonProps}>
                                                                    {child['DeviceMonitorParameterValue']?.value[accessor] ?? ''}
                                                                </TableCell>
                                                            );
                                                        }

                                                        return <TableCell {...commonProps}></TableCell>;
                                                    })
                                                }
                                                components={{
                                                    Table: (props) => <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'auto', minWidth: '100%' }} stickyHeader />,
                                                    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} sx={{ display: 'table-header-group !important' }} />),
                                                    TableRow,
                                                    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
                                                    // TableCell,
                                                }}
                                            />
                                        </Box>
                                    </TableContainer>
                            }
                        </Box>
                    </Collapse>
                </TableCell>

            </TableRow>
        </React.Fragment>
    );
}

Row.propTypes = {
    row: PropTypes.shape({
        calories: PropTypes.number.isRequired,
        carbs: PropTypes.number.isRequired,
        fat: PropTypes.number.isRequired,
        history: PropTypes.arrayOf(
            PropTypes.shape({
                amount: PropTypes.number.isRequired,
                customerId: PropTypes.string.isRequired,
                date: PropTypes.string.isRequired,
            }),
        ).isRequired,
        name: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        protein: PropTypes.number.isRequired,
    }).isRequired,
};

const useStyles = makeStyles({
    customTableHead: {
        display: 'table-header-group!important', // Use the correct CSS property without quotes
    },
});

export default function RouteCollapsibleTabTable({ data, columns, subColumns, clickViewHandler, clickExportHandler, clickDeleteHandler, openLogs, clickInfoHandler, clickSubRouteViewHandler, page, setPage, rowsPerPage, setRowsPerPage, count }) {
    const classes = useStyles();
    const [searchQuery, setSearchQuery] = React.useState('');
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('');
    const [groupedData, setGroupedData] = React.useState([]);
    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    async function onRowsPerPageChange(e, value) {
        e.stopPropagation();
        setRowsPerPage(value)
    }

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSort = (column) => {
        const isAsc = orderBy === column && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(column);
    };

    const VerticalSortIcon = () => (
        <Box sx={{ display: 'flex', flexDirection: 'column', flexDirection: 'column', alignItems: 'center' }}>
            <KeyboardArrowUpIcon />
            <KeyboardArrowDownIcon />
        </Box>
    );

    const groupRoutes = (data) => {
        let grouped = [];
        data.forEach((element) => {
            grouped.push({
                header: element,
                children: element.RouteTrackingPoints,
                route_id: element.route_id,
                device_id: element.device_id,
            })
        });
        return grouped;
    }

    React.useEffect(() => {
        if (data.length > 0) {
            const groupedData = groupRoutes(data);
            setGroupedData(groupedData);
        }
    }, [data])


    return (
        <TableContainer component={Paper}>
            <MDBox sx={{
                flexGrow: 1,
                overflow: "auto",
                width: '100%',
                minWidth: '1820px'
            }}>
                <Table aria-label="collapsible table" >
                    <TableHead classes={{ root: classes.customTableHead }}>
                        <TableRow>
                            <TableCell />
                            {columns
                                .filter((column) => column.show !== false)
                                .map((column) => (
                                    <TableCell
                                        key={column.accessor}
                                        sx={{
                                            textTransform: 'uppercase',
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                            fontSize: '0.65rem',
                                            opacity: '0.7',
                                            justifyContent: 'space-between',
                                            marginLeft: 0,
                                            color: '#ffffff',
                                            width: column.width
                                        }}
                                        sortDirection={orderBy === column.accessor ? order : false}
                                    >
                                        {column.Header}
                                        {
                                            column.Header !== 'actions' &&
                                            <TableSortLabel
                                                IconComponent={VerticalSortIcon}
                                                active={orderBy === column.accessor}
                                                direction={orderBy === column.accessor ? order : 'asc'}
                                                onClick={() => handleSort(column.accessor)}
                                            >
                                            </TableSortLabel>
                                        }
                                    </TableCell>
                                ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(groupedData)
                            .filter(group => Object.values(group.header).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())))
                            .sort((a, b) => {
                                const compareField = 'route_id';
                                if (a.header[compareField] < b.header[compareField]) return order === 'asc' ? -1 : 1;
                                if (a.header[compareField] > b.header[compareField]) return order === 'asc' ? 1 : -1;
                                return 0;
                            })
                            .map((group) => (
                                <Row
                                    key={group.header.route_id}
                                    group={group}
                                    columns={columns.filter((column) => column.show !== false)}
                                    subColumns={subColumns.filter((column) => column.show !== false)}
                                    clickViewHandler={clickViewHandler}
                                    clickExportHandler={clickExportHandler}
                                    clickDeleteHandler={clickDeleteHandler}
                                    clickInfoHandler={clickInfoHandler}
                                    clickSubRouteViewHandler={clickSubRouteViewHandler}
                                    openLogs={openLogs}
                                />
                            ))}
                    </TableBody>
                </Table>
                {
                    count > rowsPerPage ?
                        <TablePaginationActions count={count} page={page} rowsPerPage={rowsPerPage} onPageChange={handleChangePage} onRowsPerPageChange={onRowsPerPageChange} /> : ''
                }
            </MDBox>
        </TableContainer>
    );
}